<style>
th, td {
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 10px;
  padding-right: 10px;
}
</style>
<template>
    <fieldset :disabled="loading">
        <div class = 'sm:w-1/3 mx-auto mt-10'>
            <Title :title = "$t('paymentpage.title')"/>
            <!-- <div class = 'grid grid-cols-2 grid-rows-6 text-left my-5 w-3/4 sm:w-full mx-auto'>
                <div>{{$t('titleno')}}</div>
                <div>{{titleno}}</div>

                <div>{{$t('paymentpage.amounttopay')}}</div>
                <div>{{amount}}</div>

                <div>{{$t('paymentpage.amountnoticefeetopay')}}</div>
                <div>{{amountnoticefee}}</div>

                <div>{{$t('paymentpage.amountsurchargetopay')}}</div>
                <div>{{amountsurcharge}}</div>

                <div><input type="radio" name="paymentoption" value="full" @change="onChange($event)" checked> Full Amount</div>
                <div><input type="radio" name="paymentoption" value="other" @change="onChange($event)"> Other Amount</div>

                <div>{{$t('paymentpage.amount')}}</div>
                <div v-show="full"><input :value = "totalamount" class = 'bg-white rounded p-2 shadow focus:outline-none text-gray-700 mb-2 w-full' disabled/></div>
                <div v-show="other"><input ref="other" class = 'bg-white rounded p-2 shadow focus:outline-none text-gray-700 mb-2 w-full' v-model = "otheramt" placeholder="Amount (0.00)" required @keypress.enter="focusPayerName" /></div>

                <div>{{$t('paymentpage.payer')}}</div>
                <div><input ref="payer" style="text-transform: uppercase;" class = 'bg-white rounded p-2 shadow focus:outline-none text-gray-700 w-full' v-model = "payer" placeholder="Payer's Name" required/></div>
            </div> -->

            <table style="width: 100%">
                <tr>
                    <td>{{$t('titleno')}}</td>
                    <td>{{titleno}}</td>
                </tr>
                <tr>
                    <td style="width: 60%;">{{$t('paymentpage.amounttopay')}}</td>
                    <td>{{amount}}</td>
                </tr>
                <tr>
                    <td><input type="radio" name="paymentoption" value="full" @change="onChange($event)" checked> Full Amount<br></td>
                    <td><input type="radio" name="paymentoption" value="other" @change="onChange($event)"> Other Amount</td>
                </tr>
                <tr>
                    <td>{{$t('paymentpage.amount')}}</td>
                    <td>
                        <div v-show="full"><input :value = "totalamount" class = 'bg-white rounded p-2 shadow focus:outline-none text-gray-700 mb-2 w-full' disabled/></div>
                        <div v-show="other"><input ref="other" class = 'bg-white rounded p-2 shadow focus:outline-none text-gray-700 mb-2 w-full' v-model = "otheramt" placeholder="Amount (0.00)" required @keypress.enter="focusPayerName" /></div>
                    </td>
                </tr>
                <tr>
                    <td colspan="2" style="font-weight: bold; color: red;">* {{$t('paymentpage.minimumAmount')}}</td>
                </tr>
                <tr>
                    <td class="">{{$t('paymentpage.payer')}}</td>
                    <td class=""><input ref="payer" style="text-transform: uppercase;" class = 'bg-white rounded p-2 shadow focus:outline-none text-gray-700 w-full' v-model = "payer" placeholder="Payer's Name" required/></td>
                </tr>
            </table>

            <div style="text-align: center;">
                <IconButton :label = "$t('back')" @click="back"
                    svg = "M11 15l-3-3m0 0l3-3m-3 3h8M3 12a9 9 0 1118 0 9 9 0 01-18 0z"/>
                
                <button @click = "fpxPayment" class = 'm-1 bg-blue-500 hover:bg-blue-700 rounded p-2 text-white text-sm'>
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 inline-block" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <span class = 'hidden sm:inline-block ml-1'>{{ $t('paymentpage.pay') }}</span>
                </button>
            </div>
            
        </div>

        <div class='spinner' v-if='loading'></div>
    </fieldset>
</template>

<script>
import Title from '@/components/Title'
import IconButton from '@/components/IconButton'
import router from '@/router'
import axios from 'axios'
import config from '@/config'
import { Console } from 'console'

export default {
    paymentamt: 0,
    quitrentamt: 0,
    noticefeeamt: 0,
    surchargeamt: 0,
    remainingamt: 0,
    token: "",
    refno: "",

    name: "Payment",
    data:()=>{
        return {
            titleno:"",
            amount:0,
            amountnoticefee:0,
            amountsurcharge:0,
            totalamount:0,
            payer:"",
            otheramt:"",
            loading: false,
            full: true,
            other: false,
        }
    },
    components:{Title, IconButton},
    mounted:function(){
        this.$refs.payer.focus();
        this.titleno = this.$route.query.titleno
        this.amount = this.$route.query.amount
        this.amountnoticefee = this.$route.query.amountnoticefee
        this.amountsurcharge = this.$route.query.amountsurcharge
        //this.totalamount = (Math.round((Number(this.amount) + Number(this.amountnoticefee) + Number(this.amountsurcharge)) * 100) / 100).toFixed(2);
        this.totalamount = (Math.round((Number(this.amount)) * 100) / 100).toFixed(2);
    },
    methods:{
        back:function(){
            router.push({path:'/arrears', query:{titleno:this.titleno}})
        },
        onChange: function(event){
            var data = event.target.value;
            
            if(data === "full"){
                this.full = true;
                this.other = false;

                this.$nextTick(() => {
                    this.$refs.payer.focus();
                });
            }
            else{
                this.full = false;
                this.other = true;

                this.$nextTick(() => {
                    this.$refs.other.focus();
                });
            }
        },
        focusPayerName() {
            this.$refs.payer.focus();
        },
        fpxPayment: function () {
            if(this.other){
                if(this.otheramt === ""){
                    alert("Please key-in the amount");
                    this.$refs.other.focus();
                    return;
                }

                if(this.otheramt <= 0){
                    alert("Amount cannot zero amount");
                    this.$refs.other.focus();
                    return;
                }

                if(this.otheramt < 10){
                    alert("Minimum Amount is RM 10");
                    this.$refs.other.focus();
                    return;
                }
                else{
                    if(Number(this.otheramt) <= Number(this.totalamount)){
                        if(this.amountnoticefee != 0){
                            if(Number(this.otheramt) <= Number(this.amountnoticefee)){
                                this.noticefeeamt = this.otheramt;
                            }
                            else{
                                this.remainingamt = (Math.round((Number(this.otheramt) - Number(this.amountnoticefee)) * 100) / 100).toFixed(2);
                                this.noticefeeamt = this.amountnoticefee;
                            }
                        }
                        else{
                            this.noticefeeamt = 0.00;
                        }

                        if(this.amountsurcharge != 0){
                            if(Number(this.remainingamt) <= Number(this.amountsurcharge)){
                                this.surchargeamt = this.remainingamt;
                            }
                            else{
                                this.remainingamt = (Math.round((Number(this.remainingamt) - Number(this.amountsurcharge)) * 100) / 100).toFixed(2);
                                this.surchargeamt = this.amountsurcharge;
                            }
                        }
                        else{
                            this.surchargeamt = 0.00;
                        }

                        if(this.amount != 0){
                            if(Number(this.remainingamt) <= Number(this.amount)){
                                this.quitrentamt = this.remainingamt;
                            }
                            else{
                                this.quitrentamt = this.otheramt;
                            }
                        }

                        this.paymentamt = this.otheramt;
                    }
                    else if(Number(this.otheramt) > Number(this.totalamount)){
                        if(this.amountnoticefee != 0){
                            this.remainingamt = (Math.round((Number(this.otheramt) - Number(this.amountnoticefee)) * 100) / 100).toFixed(2);
                            this.noticefeeamt = this.amountnoticefee;
                        }
                        else{
                            this.noticefeeamt = 0.00;
                        }

                        if(this.amountsurcharge != 0){
                            this.remainingamt = (Math.round((Number(this.remainingamt) - Number(this.amountsurcharge)) * 100) / 100).toFixed(2);
                            this.surchargeamt = this.amountsurcharge;
                        }
                        else{
                            this.surchargeamt = 0.00;
                        }

                        if(this.amount != 0){
                            this.quitrentamt = this.remainingamt;
                        }
                        
                        this.paymentamt = this.otheramt;
                    }
                }
            }
            else{
                if(this.totalamount < 10){
                    alert("Minimum Amount is RM 10");
                    return;
                }
                this.paymentamt = this.totalamount;
                this.quitrentamt = this.amount;
                this.noticefeeamt = this.amountnoticefee;
                this.surchargeamt = this.amountsurcharge;
            }
            
            if(this.payer == ""){
                alert("Please key-in the payer name");
                this.$refs.payer.focus();
                return;
            }

            console.log("paymentamt: " + this.paymentamt);
            console.log("quitrentamt: " + this.quitrentamt);
            console.log("noticefeeamt: " + this.noticefeeamt);
            console.log("surchargeamt: " + this.surchargeamt);

            const characters ='ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
            let random = "";
            const charactersLength = characters.length;
            for ( let i = 0; i < 20; i++ ) {
                random += characters.charAt(Math.floor(Math.random() * charactersLength));
            }

            this.refno = "FPX-" + random;

            if(this.refno != "" || this.refno != null){
                const usrid = "KRM";
                const usrpass = "ItUxP7jET9F9DIn2bb0Mvw";

                this.loading = true;

                axios.post(config.GENTOKEN_URL, { "UsrID": `${usrid}`, "UsrPass": `${usrpass}` })
                .then(res => {
                    if(res.data.success){
                        this.token = res.data.token;

                        console.log(this.token);

                        const refval = "";
                        const systemid = "LRCIS";
                        const addinfo = "10, " + this.titleno;
                        const prodtype = "QUIT RENT";
                        const buyemail = "";
                        const payername = this.payer.replace(" ", "%20");
                        const callback = config.ARREARS_URL + "?titleno=" + this.titleno; 
                        const callbackapi = config.FPXPAYMENT_SUCCESS_URL + "/" + this.refno + "/" + this.titleno + "/" + this.paymentamt 
                            + "/" + this.payer + "/" + systemid;
                        const callbackapi2 = "";
                        
                        console.log(callback);
                        console.log(callbackapi);

                        axios.post(config.INSPG_URL, 
                            { 
                                "WsID": `${usrid}`, "RefNo": `${this.refno}`, "RefVal": `${refval}`, "SystemID": `${systemid}`, 
                                "PaymentAmount": `${this.paymentamt}`, 
                                "AddInfo": `${addinfo}`, "ProdType": `${prodtype}`, 
                                "CallBack": `${callback}`,
                                "BuyEmail": `${buyemail}`, "BuyName": `${this.payer}`, 
                                "CallBackAPI": `${callbackapi}`, "CallBackAPI2": `${callbackapi2}`
                            }, 
                            {
                                headers: {
                                    'Authorization': `${this.token}`
                                }
                            }
                        )
                        .then(res => {
                            console.log(res.data);
                            if(res.data.success){
                                let fpxrefno = res.data.NewRefNo;
                                let fpxrefno2 = res.data.NewRefNo2;

                                const paygateurl = config.PAYGATE_URL + "?ref1=" + fpxrefno + "&ref2=" + fpxrefno2;
                                console.log(paygateurl);

                                console.log(config.FPX_URL + "?titleno=" + this.titleno + "&paymentamt=" + this.paymentamt 
                                    + "&payername=" + this.payer + "&quitrentamt=" + this.quitrentamt + "&noticefeeamt=" + this.noticefeeamt 
                                    + "&surchargeamt=" + this.surchargeamt + "&refno=" + this.refno + "&fpxrefno=" + fpxrefno
                                    + "&systemid=" + systemid)

                                axios.post(config.FPX_URL + "?titleno=" + this.titleno + "&paymentamt=" + this.paymentamt 
                                    + "&payername=" + this.payer + "&quitrentamt=" + this.quitrentamt + "&noticefeeamt=" + this.noticefeeamt 
                                    + "&surchargeamt=" + this.surchargeamt + "&refno=" + this.refno + "&fpxrefno=" + fpxrefno
                                    + "&systemid=" + systemid)
                                .then(res => {
                                    if(res.data.status === "OK"){
                                        window.open(paygateurl, '_blank');
                                    }
                                    else{
                                        alert("Error");
                                    }
                                }).finally(() => {
                                    this.loading = false;
                                })
                            }
                            else{
                                alert("Session Expired, please try again");
                            }
                        }).finally(() => {
                            this.loading = false;
                        });
                    }
                }).finally(() => {
                    this.loading = false;
                });
            }

            // this.loading = true;

            // axios.get(config.FPX_URL + "?titleno=" + this.titleno + "&paymentamt=" + this.paymentamt + "&payername=" + this.payer + "&quitrentamt=" + this.quitrentamt + "&noticefeeamt=" + this.noticefeeamt + "&surchargeamt=" + this.surchargeamt)
            // .then(res => {
            //     if(res.data.status === "OK"){
            //         const json = JSON.stringify({ "UsrID": "KRM", "UsrPass": "ItUxP7jET9F9DIn2bb0Mvw" });

            //         customConfig = {
            //             headers: {
            //                 'Content-Type': 'application/json'
            //             }   
            //         };

            //         axios.post(config.GENTOKEN_URL, json, customConfig)
            //         .then(res => {
            //             console.log(res);
            //         }).finally(() => {
            //             this.loading = false;
            //         });
            //     }
            //     else{
            //         alert("Error");
            //     }
            // }).finally(() => {
            //     this.loading = false;
            // });
        }
    }
}
</script>